import dashboardTexture from "./dashboard-texture.webp";
import fengniaoMark from "./fengniao-mark.webp";
import fengniaoTokenHero from "./fengniao-token-hero.webp";
import noise from "./noise.svg";

export const assets = {
  fengniaoMark,
  fengniaoTokenHero,
  dashboardTexture,
  noise,
};
